import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import nl from './locales/nl.json';

export const LANGUAGES = { nl: 'Nederlands', en: 'English' } as const;
export type Language = keyof typeof LANGUAGES;

void i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl }, en: { translation: en } },
  lng: 'nl',
  fallbackLng: 'nl',
  interpolation: { escapeValue: false },
});

export default i18n;
